// Auto-generated - do not edit manually
// Run "npm run build" in the ahicon package to regenerate

export type StoresprintIconName =
  | "KPI"
  | "PLU"
  | "account-group"
  | "account-hard-hat"
  | "account-tie"
  | "activity"
  | "add-circle"
  | "add"
  | "albums-outline"
  | "analytics"
  | "android"
  | "app-store"
  | "apple"
  | "archive"
  | "arrow-down"
  | "arrow-left"
  | "arrow-right-circle"
  | "arrow-right"
  | "arrow-up-circle"
  | "arrow-up-right"
  | "attachment"
  | "baby-carriage"
  | "baguette"
  | "barcode-scanner"
  | "basket"
  | "bed"
  | "bread-slice"
  | "broom"
  | "calendar"
  | "camera"
  | "carrot"
  | "cart-outline"
  | "cart"
  | "cash-register"
  | "cash"
  | "check"
  | "cheese"
  | "chevron-down"
  | "chevron-left"
  | "chevron-right"
  | "chevron-up"
  | "clear"
  | "clock"
  | "coffe"
  | "connect"
  | "connection-error"
  | "cookie"
  | "corner-down-right"
  | "crown"
  | "cupcake"
  | "currency"
  | "dashboard"
  | "deadline"
  | "desk-lamp"
  | "developer"
  | "dolly"
  | "drag"
  | "duplicate"
  | "edit"
  | "email"
  | "employee-role"
  | "expand-outline"
  | "eye"
  | "feedback"
  | "file-minus"
  | "files"
  | "filter"
  | "fish"
  | "flag"
  | "flower"
  | "focus-mode"
  | "food"
  | "fork-knife"
  | "forklift"
  | "fridge"
  | "google-play"
  | "group-actor"
  | "guest-actor"
  | "hamburger"
  | "hammer-wrench"
  | "help"
  | "hide"
  | "image"
  | "info"
  | "instructions"
  | "integration-flourish-praise"
  | "integration"
  | "iot"
  | "issue"
  | "key-outline"
  | "laptop"
  | "learn-more"
  | "link"
  | "locked"
  | "log-in"
  | "market"
  | "meat"
  | "message"
  | "milk"
  | "minus"
  | "more-outlined"
  | "more-vertical"
  | "more"
  | "notification"
  | "number-input"
  | "number-task"
  | "org"
  | "other"
  | "phone"
  | "pin-off"
  | "pin"
  | "pineapple"
  | "play"
  | "prio"
  | "product"
  | "remove-outline"
  | "remove"
  | "reorder"
  | "routine"
  | "routing"
  | "rvm"
  | "save-replace"
  | "scan-barcode"
  | "scan"
  | "schedule"
  | "search"
  | "send"
  | "settings"
  | "show"
  | "shuffle"
  | "signal-cellular-2"
  | "signal-cellular-3"
  | "signal"
  | "soda"
  | "sofa"
  | "star-outlined"
  | "star"
  | "steak"
  | "store"
  | "storesprint-update"
  | "suggestion"
  | "sun"
  | "tag"
  | "team-home"
  | "team-layout"
  | "team-schedule"
  | "template"
  | "text-edit"
  | "text-input"
  | "text-response"
  | "text-task"
  | "timezone"
  | "todo-category"
  | "todo-response"
  | "touch"
  | "trash"
  | "truck"
  | "tshirt"
  | "tv-sharp"
  | "tv"
  | "update"
  | "user-add"
  | "user-remove"
  | "user"
  | "users"
  | "verified-actor"
  | "video"
  | "watermelon"
  | "widget"
  | "winner"
  | "workspace"
  | "zap";

export const iconNames: StoresprintIconName[] = [
  "KPI",
  "PLU",
  "account-group",
  "account-hard-hat",
  "account-tie",
  "activity",
  "add-circle",
  "add",
  "albums-outline",
  "analytics",
  "android",
  "app-store",
  "apple",
  "archive",
  "arrow-down",
  "arrow-left",
  "arrow-right-circle",
  "arrow-right",
  "arrow-up-circle",
  "arrow-up-right",
  "attachment",
  "baby-carriage",
  "baguette",
  "barcode-scanner",
  "basket",
  "bed",
  "bread-slice",
  "broom",
  "calendar",
  "camera",
  "carrot",
  "cart-outline",
  "cart",
  "cash-register",
  "cash",
  "check",
  "cheese",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clear",
  "clock",
  "coffe",
  "connect",
  "connection-error",
  "cookie",
  "corner-down-right",
  "crown",
  "cupcake",
  "currency",
  "dashboard",
  "deadline",
  "desk-lamp",
  "developer",
  "dolly",
  "drag",
  "duplicate",
  "edit",
  "email",
  "employee-role",
  "expand-outline",
  "eye",
  "feedback",
  "file-minus",
  "files",
  "filter",
  "fish",
  "flag",
  "flower",
  "focus-mode",
  "food",
  "fork-knife",
  "forklift",
  "fridge",
  "google-play",
  "group-actor",
  "guest-actor",
  "hamburger",
  "hammer-wrench",
  "help",
  "hide",
  "image",
  "info",
  "instructions",
  "integration-flourish-praise",
  "integration",
  "iot",
  "issue",
  "key-outline",
  "laptop",
  "learn-more",
  "link",
  "locked",
  "log-in",
  "market",
  "meat",
  "message",
  "milk",
  "minus",
  "more-outlined",
  "more-vertical",
  "more",
  "notification",
  "number-input",
  "number-task",
  "org",
  "other",
  "phone",
  "pin-off",
  "pin",
  "pineapple",
  "play",
  "prio",
  "product",
  "remove-outline",
  "remove",
  "reorder",
  "routine",
  "routing",
  "rvm",
  "save-replace",
  "scan-barcode",
  "scan",
  "schedule",
  "search",
  "send",
  "settings",
  "show",
  "shuffle",
  "signal-cellular-2",
  "signal-cellular-3",
  "signal",
  "soda",
  "sofa",
  "star-outlined",
  "star",
  "steak",
  "store",
  "storesprint-update",
  "suggestion",
  "sun",
  "tag",
  "team-home",
  "team-layout",
  "team-schedule",
  "template",
  "text-edit",
  "text-input",
  "text-response",
  "text-task",
  "timezone",
  "todo-category",
  "todo-response",
  "touch",
  "trash",
  "truck",
  "tshirt",
  "tv-sharp",
  "tv",
  "update",
  "user-add",
  "user-remove",
  "user",
  "users",
  "verified-actor",
  "video",
  "watermelon",
  "widget",
  "winner",
  "workspace",
  "zap",
];
